module.exports = __webpack_public_path__ + "51b5558658fa7b85794ed5747eb28135.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_6-mobile.png
// module id = 130
// module chunks = 1